import { DefaultPlayHost } from '@/integration/default-host-system';
import { HostSystem } from '@/generated/play-api';

export const PlayWebGenericHost = new DefaultPlayHost(HostSystem.GENERAL, {
    name: 'AI Automation Assistant',
    initialize() {
        return {};
    },
});
